import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import RepositoryResponse from '@/types/repositoryResponse';
import { SubstanceSummary } from '@/types/substanceSummary';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';

export const substanceTrackerRepository = {
  async getSummary({
    host,
    personId,
    endOn
  }: {
    host: string;
    personId: string;
    endOn: string;
  }): Promise<RepositoryResponse<SubstanceSummary>> {
    try {
      const path = `/api/dugout/substance_trackers/summaries/?person_id=${personId}&&isActive=true&&end_on=${endOn}`;
      const response = await ajax.get({
        url: `${host}${path}`
      });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      return defaultRepositoryError(error as AxiosError, 'Failed to fetch substance summary.');
    }
  }
};

const SubstanceTrackerRepository = () => {
  const { host } = useContext(AppContext);
  const today = new Date();
  const endOn = new Date(today);
  // We want 14 days total, but today is inclusive so we subtract 13
  endOn.setDate(today.getDate() - 13);
  const formattedEndOn = endOn.toISOString().split('T')[0];
  return {
    async getSummary(personId: string): Promise<RepositoryResponse<SubstanceSummary>> {
      return substanceTrackerRepository.getSummary({ host, personId, endOn: formattedEndOn });
    }
  };
};

export default SubstanceTrackerRepository;
